// extracted by mini-css-extract-plugin
export default {"spinner-wrapper":"spinner_spinner-wrapper__WdgSH","spinner":"spinner_spinner__i6-sY","spin":"spinner_spin__6cWFK"};